module.exports = __webpack_public_path__ + "img/ic-lineplot-square.64243219.svg";